var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.736,
    y1: 1,
    x2: -2.169,
    y2: -0.108,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28348b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ce2cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_230",
    "data-name": "Groupe 230",
    transform: "translate(0.289 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 10.5,
    cy: 10,
    rx: 10.5,
    ry: 10,
    transform: "translate(-0.289 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(4.711 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_143",
    "data-name": "Groupe 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_302",
    "data-name": "Trac\\xE9 302",
    d: "M10.71,85.333H.579A.581.581,0,0,0,0,85.912V92.28a.581.581,0,0,0,.579.579H10.71a.581.581,0,0,0,.579-.579V85.912A.581.581,0,0,0,10.71,85.333Zm-.217.434L5.977,89.154a.605.605,0,0,1-.666,0L.8,85.767Zm-2.412,3.61,2.46,3.039.008.008H.74l.008-.008,2.46-3.039A.217.217,0,0,0,2.87,89.1L.434,92.113V86.039L5.051,89.5a1.036,1.036,0,0,0,1.187,0l4.617-3.463v6.075L8.418,89.1a.217.217,0,0,0-.337.273Z",
    transform: "translate(0 -85.333)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.23e6c9a2e74b7e83dfe5d90ecab3ffbc.svg";
export { ForwardRef as ReactComponent };